import { render } from "./HistoPathologyReport.vue?vue&type=template&id=4cd610a5"
import script from "./HistoPathologyReport.vue?vue&type=script&lang=js"
export * from "./HistoPathologyReport.vue?vue&type=script&lang=js"

import "./HistoPathologyReport.vue?vue&type=style&index=0&id=4cd610a5&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__